import { useQuery } from "@tanstack/react-query";
import { readData } from "@/lib/services/data-layer";
import { url } from "@/lib/services/data-layer/core";
import { virtualPosItem } from "@/lib/types/DTO/core";

const getVirtualPosByVirtualPosId = async (
  virtualPosId?: number
): Promise<virtualPosItem> => {
  return await readData(url + `vpos/${virtualPosId}`);
};

export const useGetVirtualPosByVirtualPosIdQuery = (
  virtualPosId?: number,
  shouldFetch: boolean = true
) => {
  return useQuery({
    queryKey: ["virtual-pos-by-virtual-pos-id", virtualPosId],
    queryFn: () => getVirtualPosByVirtualPosId(virtualPosId),
    enabled: !!virtualPosId && shouldFetch,
    refetchOnMount: "always",
    staleTime: 0,
  });
};
